import React, { useState } from "react";
import {
  CircularProgress,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { Plus } from "react-feather";
import {
  AMPLITUDE_KEYS,
  FEEDBACK_MESSAGES,
} from "../../../../storage/constants";
import API from "../../../../axios/instances/API";
import * as amplitude from "@amplitude/analytics-browser";

const handleApiError = (error) => {
  const errorObj = error?.response?.data?.error;

  if (errorObj) {
    return {
      title: errorObj.title,
      body: errorObj.details,
    };
  }

  return {
    title: "ERROR",
    body: FEEDBACK_MESSAGES.GENERIC_ERROR,
  };
};

const ModalWrapper = styled(Paper)`
  padding: 20px;
  min-width: min(540px, 96vw);
  max-width: 600px;
  text-align: left;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 6px;
  border: 2px solid black;
`;

const CHARACTER_LIMIT = 100;

const CreateModuleModal = () => {
  const [quizName, setQuizName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [charsMaxed, setCharsMaxed] = useState(false);
  const history = useHistory();

  const createQuiz = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorAlert(false);
    const sendObj = {};
    sendObj.name = quizName;

    try {
      const { data } = await API.post("dashboard/quiz/", sendObj);
      amplitude.track(AMPLITUDE_KEYS.CUSTOM_MODULE_CREATED);
      setIsSubmitting(false);
      history.push({
        pathname: `/modules/quiz-builder/${data.id}`,
        state: {
          newQuiz: true,
        },
      });
    } catch (error) {
      setIsSubmitting(false);
      const errorObj = handleApiError(error);
      return setErrorAlert(errorObj);
    }
  };

  const launchDisabled = quizName.length < 3 || isSubmitting || charsMaxed;

  const handleUpdateModName = (e) => {
    const { value } = e.target;
    const numChars = value?.length || 0;
    if (numChars > CHARACTER_LIMIT) {
      return setCharsMaxed(true);
    }
    setCharsMaxed(false);
    setQuizName(value);
  };

  return (
    <ModalWrapper>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <Typography variant="h3">Create Module</Typography>
      </div>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        sx={{ mb: 6, ml: 0.5 }}
      >
        Input a name to create a new module.
      </Typography>
      <form id="createQuizForm" onSubmit={createQuiz}>
        <TextField
          variant="outlined"
          fullWidth
          autoFocus
          value={quizName}
          onChange={handleUpdateModName}
          label="Module Name"
          size="small"
          error={charsMaxed}
          helperText={
            charsMaxed &&
            `${CHARACTER_LIMIT} characters maximum for module name`
          }
          sx={{ mb: 4 }}
        />
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            type="submit"
            form="createQuizForm"
            variant="contained"
            style={{
              backgroundColor: launchDisabled ? "darkgrey" : "#337AB7",
              color: "#eeeeee",
              marginLeft: "auto",
            }}
            color="primary"
            disabled={launchDisabled}
            startIcon={
              isSubmitting ? (
                <CircularProgress size={16} sx={{ color: "white" }} />
              ) : (
                <Plus color="white" height={14} width={14} />
              )
            }
          >
            {isSubmitting ? "Creating Module" : "Create Module"}
          </Button>
        </div>
      </form>
      {errorAlert && (
        <Alert
          severity="error"
          sx={{ mt: 2 }}
          onClose={() => setErrorAlert(false)}
        >
          <p style={{ fontWeight: "600", fontSize: 13 }}>{errorAlert?.title}</p>
          <p style={{ fontWeight: "400", fontSize: 12 }}>{errorAlert?.body}</p>
        </Alert>
      )}
    </ModalWrapper>
  );
};

export default CreateModuleModal;
